import React, { useState } from "react";
import PropTypes from "prop-types";

import { Select, SearchableInput } from "@octane/spark";

import copy from "../copy.json";

export const Make = ({ value, options, disabled, onChange, hideNoneOption = false }) => {
    const [searchPhrase, setSearchPhrase] = useState('');
    const normalizedSearchPhrase = searchPhrase.trim().toLowerCase();
    
    const handleSelection = (makeId) => {
        if (makeId === "none") {
            setSearchPhrase('');
            return onChange({ id: "none", name: "none" });
        }
        const makeSelected = options.find((option) => option.id === makeId);
        setSearchPhrase('');
        onChange(makeSelected);
    };

    const filteredOptions = normalizedSearchPhrase
        ? options.filter((option) =>
            option.name
                .toLowerCase()
                .split(/\s+/)
                .some((word) => word.startsWith(normalizedSearchPhrase))
          )
        : options;
    const showNoResults = Boolean(normalizedSearchPhrase) && filteredOptions.length === 0;

    const displayValue = value === "none" ? "" : value;

    return (
        <Select
            id="select-make"
            label={copy.fields.make.label}
            placeholder="Search Makes"
            value={displayValue}
            disabled={disabled}
            onChange={handleSelection}
            searchable
            searchComponent={
                <div
                    onKeyDownCapture={(event) => event.stopPropagation()}
                    onKeyUpCapture={(event) => event.stopPropagation()}
                >
                    <SearchableInput
                        id="make-search"
                        placeholder="Search makes"
                        value={searchPhrase}
                        onChange={(nextValue) => setSearchPhrase(nextValue)}
                        onClear={() => setSearchPhrase("")}
                        variant="primary"
                    />
                </div>
            }
        >
            {!hideNoneOption && !normalizedSearchPhrase && (
                <Select.Option key="none" value="none">
                    {copy.fields.make.notSure}
                </Select.Option>
            )}

            {showNoResults ? (
                <Select.Option key="no-results" value="__no_results__" disabled>
                    No results found.
                </Select.Option>
            ) : (
                filteredOptions.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                        {option.name}
                    </Select.Option>
                ))
            )}
        </Select>
    );
};

Make.propTypes = {
    value: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        })
    ).isRequired,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    hideNoneOption: PropTypes.bool,
};
